module.exports = __webpack_public_path__ + "images/home/fioleCybersecurite.6c18bea3.svg";